import {
    Button, Flex, Heading, ListItem, OrderedList, Text,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export function AuthError() {
    return (
        <Flex flexDir="column" alignItems="start" width="100%">
            <Heading fontSize="3xl" mb={4}>
                This page is restricted
            </Heading>
            <Text fontSize="lg" mb={4}>There are a few reasons why you might not be able to access this page:</Text>
            <OrderedList spacing={2} py={4}>
                <ListItem>
                    <Text>
                        You do not have permission to access this page. If you require
                        access to this page, we recommend that you speak to one of our staff.
                    </Text>
                </ListItem>
                <ListItem>
                    <Text>
                        You are not logged in to your account. Please log in to your account.
                    </Text>
                </ListItem>
            </OrderedList>
            <Button as={Link} to="/auth/login" mt={6} variant="rounded-solid" size="cta-md" colorScheme="primary">
                Try logging in again
            </Button>
        </Flex>
    );
}
